module.exports = __webpack_public_path__ + "img/bm.c83a8bb5.svg";